module.exports = __webpack_public_path__ + "images/Bopis_Boss.svg";